import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, unref as _unref } from "vue"

import { IonApp } from "@ionic/vue";
import { useI18n } from "vue-i18n";
import { useLocaleStore } from "./modules/locale/store/locale";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const i18n = useI18n();
const localeStore = useLocaleStore();

const dir = computed(() => {
  const language = localeStore.availableLanguages.find(
    (lang) => lang.code === i18n.locale.value
  );
  return language?.dir === "rtl" ? "rtl" : "ltr";
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(IonApp), { dir: dir.value }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["dir"]))
}
}

})